import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../ui/select';
import { UserCog, X } from 'lucide-react';
import { userApi, projectApi } from '../../lib/api';
import { toast } from 'sonner';

const UNASSIGN = '__none__';

export default function ProjectManagerDialog({ open, onOpenChange, project, onSaved }) {
  const [pms, setPms] = useState([]);
  const [selected, setSelected] = useState(UNASSIGN);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSelected(project?.project_manager_id || UNASSIGN);
    userApi.getAll().then((r) => {
      const list = (r.data || []).filter((u) => u.role === 'project_manager' && u.is_active !== false);
      setPms(list);
    }).catch(() => setPms([]));
  }, [open, project]);

  const save = async () => {
    setBusy(true);
    try {
      const userId = selected === UNASSIGN ? null : selected;
      await projectApi.updateProjectManager(project.id, userId);
      toast.success(userId ? 'Project Manager assegnato' : 'Project Manager rimosso');
      onOpenChange(false);
      onSaved && onSaved();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error((typeof d === 'object' ? d?.message : d) || 'Errore assegnazione PM');
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pm-assign-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><UserCog className="w-5 h-5" /> Project Manager</DialogTitle>
          <DialogDescription>Assegna o rimuovi il Project Manager responsabile del progetto. Solo PM attivi selezionabili.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-xs font-medium">Project Manager</label>
          <Select value={selected} onValueChange={setSelected}>
            <SelectTrigger data-testid="pm-select"><SelectValue placeholder="Seleziona un PM" /></SelectTrigger>
            <SelectContent>
              <SelectItem value={UNASSIGN} data-testid="pm-option-none">Non assegnato</SelectItem>
              {pms.map((u) => (
                <SelectItem key={u.id} value={u.id} data-testid={`pm-option-${u.id}`}>
                  {`${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {pms.length === 0 && <p className="text-xs text-[#a3a3a3] italic">Nessun Project Manager attivo disponibile.</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button onClick={save} disabled={busy} className="bg-[#FF7819] hover:bg-[#E56A0F]" data-testid="pm-save-btn">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
